export const AIDEXA_SET_USER = 'AIDEXA_SET_USER';
export const AIDEXA_RESET = 'AIDEXA_RESET';

export const ANALYTICS_IDENTITY = 'ANALYTICS_IDENTITY';
export const ANALYTICS_RESET = 'ANALYTICS_RESET';
